import { useState } from "react";
import { Check, EyeOff, Trash2 } from "lucide-react";
import { adminApi } from "@/lib/adminApi";

export const STATUS_STYLES = {
  pending: "bg-amber-50 text-amber-700 border border-amber-200",
  approved: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  hidden: "bg-slate-100 text-slate-600 border border-slate-200",
};

const BTN =
  "inline-flex items-center gap-1 rounded border px-2.5 py-1.5 font-mono-sub text-[11px] font-bold uppercase tracking-wider transition-colors disabled:opacity-50";

/** Approve / hide / delete controls for one review row. */
export function ReviewActions({ review, onChanged }) {
  const [busy, setBusy] = useState(false);

  const setStatus = async (status) => {
    setBusy(true);
    try {
      await adminApi.patch(`/admin/reviews/${review.id}`, { status });
      await onChanged();
    } finally {
      setBusy(false);
    }
  };

  const remove = async () => {
    if (!window.confirm("Delete this review permanently?")) return;
    setBusy(true);
    try {
      await adminApi.delete(`/admin/reviews/${review.id}`);
      await onChanged();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex justify-end gap-2">
      {review.status !== "approved" && (
        <button type="button" data-testid={`admin-review-approve-${review.id}`} disabled={busy} onClick={() => setStatus("approved")} className={`${BTN} border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-100`}>
          <Check className="h-3 w-3" aria-hidden="true" /> Approve
        </button>
      )}
      {review.status !== "hidden" && (
        <button type="button" data-testid={`admin-review-hide-${review.id}`} disabled={busy} onClick={() => setStatus("hidden")} className={`${BTN} border-slate-200 bg-white text-slate-600 hover:bg-slate-50`}>
          <EyeOff className="h-3 w-3" aria-hidden="true" /> Hide
        </button>
      )}
      <button type="button" data-testid={`admin-review-delete-${review.id}`} disabled={busy} onClick={remove} className={`${BTN} border-red-200 bg-white text-red-600 hover:bg-red-50`} aria-label="Delete review">
        <Trash2 className="h-3 w-3" aria-hidden="true" />
      </button>
    </div>
  );
}
